// src/HeroPage/ConsultExperts.tsx
import React from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import consultImg from "../assests/consultImg.webp";
import ServiceBadges from "./ServiceBadges";

const ConsultExperts: React.FC = () => {
  const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_PHONE;

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hello, I would like to schedule an appointment with your expert team to receive personalized recommendations and guidance for my jewellery selection.",
    );
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Box sx={{ backgroundColor: "white", py: { xs: 6, sm: 8, md: 10 } }}>
        <Container maxWidth="xl">
          <Grid container alignItems="center" spacing={{ xs: 4, md: 6 }}>
            {/* LEFT */}
            <Grid item xs={12} md={6}>
              <Box sx={{ maxWidth: 680, ml: { md: 2, lg: 4 } }}>
                {/* Headline elegant serif, very large, tight leading */}
                <Typography
                  component="h2"
                  sx={{
                    fontFamily: `"Playfair Display", serif`,
                    fontWeight: 600,
                    color: "#0B0B0B",
                    letterSpacing: 0,
                    lineHeight: { xs: 1.05, md: 1.03 },
                    fontSize: { xs: "2rem", sm: "2.9rem", md: "4rem" },
                    whiteSpace: "pre-line",
                  }}
                >
                  {"CONSULT OUR\nEXPERTS"}
                </Typography>

                {/* Subcopy darker, slightly larger */}
                <Typography
                  sx={{
                    mt: { xs: 2.5, md: 3 },
                    color: "#1A1A1A",
                    opacity: 0.9,
                    fontSize: { xs: "1rem", md: "1.15rem" },
                    lineHeight: 1.65,
                    maxWidth: 560,
                  }}
                >
                  Get personalized recommendations so you can make confident,
                  informed choices.
                </Typography>

                {/* CTA now opens WhatsApp */}
                <Button
                  variant="contained"
                  onClick={handleWhatsAppClick}
                  sx={{
                    mt: { xs: 3, md: 4 },
                    backgroundColor: "#0F0F0F",
                    color: "#FFFFFF",
                    borderRadius: 999,
                    fontWeight: 700,
                    px: { xs: 3.5, md: 4.5 },
                    py: { xs: 1.25, md: 1.35 },
                    fontSize: { xs: 15.5, md: 16.5 },
                    textTransform: "none",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#111111",
                      boxShadow: "none",
                    },
                  }}
                >
                  Set an Appointment
                </Button>
              </Box>
            </Grid>

            {/* RIGHT */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: "relative",
                  mr: { md: 0, lg: 0, xl: 0 },
                  ml: { md: -2, lg: -4 },
                  minHeight: { xs: 260, sm: 320, md: 420 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                <Box
                  component="img"
                  loading="lazy"
                  decoding="async"
                  src={consultImg}
                  alt="Consult our experts"
                  sx={{
                    width: { xs: "80%", sm: "76%", md: "86%" },
                    maxWidth: { md: 640, lg: 760, xl: 880 },
                    height: "auto",
                    display: "block",
                    objectFit: "contain",
                    filter: "drop-shadow(0 18px 40px rgba(0,0,0,.08))",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <ServiceBadges />
    </>
  );
};

export default ConsultExperts;
